<template>
    <filtered-consents-list
        :consents='consents'
        @filter="filterChanged"
    >
    </filtered-consents-list>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'Intent',
        props: {
            issuer: { type: String, required: true },
            intent: { type: String, required: true },
        },
        data() {
            return {
            };
        },
        computed: {
            ...mapState('intents', {
                consents: state => state.consents,
            }),
        },
        methods: {
            filterChanged(filter) {
                const issuer = this.issuer;
                const intent = this.intent;

                this.$store.dispatch('intents/LIST_INTENT_CONSENTS', { issuer, intent, filter });
            },
        },
        created() {
            const issuer = this.issuer;
            const intent = this.intent;
            const filter = 'all';

            this.$store.commit('nav/BREADCRUMBS', [
                { id: 'intents', text: 'Intents', to: '/intents' },
                { id: 'consents', text: 'Consents', to: `/intents/${issuer}/${intent}` },
            ]);

            this.$store.dispatch('intents/LIST_INTENT_CONSENTS', { issuer, intent, filter });
        },
    };
</script>

<style>
</style>



// WEBPACK FOOTER //
// Intent.vue?bc7281aa